import * as i0 from "@angular/core";
var GetloadingService = /** @class */ (function () {
    function GetloadingService() {
        this.maskCounter = 0;
        this.maskCounter = 0;
    }
    /**
     * loading 动画控制方法
     * @param text 弃用
     * @param openMask 是否打开 loading 动画 （只有值为 true 时有意义）
     * @param closeMask 是否关闭 loading 动画 （只有 openMask 是 true 时有意义）
     */
    GetloadingService.prototype.getMask = function (text, openMask, closeMask) {
        if (closeMask === void 0) { closeMask = false; }
        if (closeMask) {
            this.maskCounter -= 1;
            if (this.maskCounter > 0) {
                return;
            }
            document.body.style.overflow = '';
            var getLoad = document.getElementsByClassName('loader')[0];
            if (getLoad === undefined) {
                return;
            }
            getLoad.parentNode.removeChild(getLoad);
        }
        else if (openMask) {
            this.maskCounter += 1;
            document.body.style.overflow = 'hidden';
            var getEl = document.getElementsByClassName('loader');
            if (getEl.length < 1) {
                document.body.style.overflow = 'hidden';
                var loadDiv = document.createElement('div');
                loadDiv.className = 'loader';
                document.body.appendChild(loadDiv);
            }
        }
    };
    GetloadingService.prototype.isMaskEngage = function () {
        var getEl = document.getElementsByClassName('loader');
        if (getEl.length < 1) {
            return false;
        }
        else {
            return true;
        }
    };
    GetloadingService.ngInjectableDef = i0.defineInjectable({ factory: function GetloadingService_Factory() { return new GetloadingService(); }, token: GetloadingService, providedIn: "root" });
    return GetloadingService;
}());
export { GetloadingService };
